<template>
  <bita-modal
    id="tickets"
    title="نوبت های راننده"
    :modal-lg="true"
    :isLoading="isLoadingModal"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-grid
        v-if="showGrid"
        ref="logGrid"
        :columns="gridColumns"
        :read-data="readData"
        :hasRow="false"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  data() {
    return {
      isLoadingModal: false,
      showGrid: false,
      driver: {},
    };
  },
  computed: {
    gridColumns() {
      return [
        {
          title: "ترمینال",
          template: (e) => (e.terminal_name ? e.terminal_name : "-"),
          width: "50px",
        },
        {
          title: "سالن",
          template: (e) => (e.salon_name ? e.salon_name : "-"),
          width: "90px",
        },
        {
          title: "وضعیت",
          template: (e) => (e.status ? this.statusText(e) : "-"),
          width: "70px",
        },
        {
          title: "تاریخ انقضاء",
          template: (e) =>
            e.expire_at ? this.$getJalaliDateTime(e.expire_at) : "-",
          width: "90px",
        },
        {
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "-",
          width: "90px",
        },
      ];
    },
  },
  methods: {
    statusText(e) {
      if (e.status == 3) {
        return `<span class='label' style="color:white;background-color:#FF0000">باطل شده</span>`;
      } else if (e.status == 2) {
        return `<span class='label' style="color:white;background-color:#FF0000">برنده شده</span>`;
      } else if (e.active == false) {
        return `<span class='label' style="color:white;background-color:#FF0000">منقضی شده</span>`;
      } else {
        return `<span class='label' style="color:white;background-color:#60e95f">فعال</span>`;
      }
    },
    setInitialData(_driver) {
      this.showGrid = true;
      this.driver = _driver;
    },
    readData(e) {
      this.isLoadingModal = true;
      this.$persistClient("get", `/drivers/${this.driver.user.id}/tickets`)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => e.success([]))
        .finally(() => (this.isLoadingModal = false));
    },
    onCloseModal() {
      this.showGrid = false;
    },
  },
};
</script>
